import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefilling = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	x: 0,
	y: 0,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#111}"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 4H4v16h16V4zm-2 14H6V6h12v12z",
			className: "st0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 4v18H2V4H0v20h24V4z",
			className: "st0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m16 12.3-1.4-1.4-1.6 1.8V8h-2v4.7l-1.6-1.8L8 12.3l4 4.2z",
			className: "st0"
		})
	]
});
export default SvgRefilling;
